import React from "react";
import Type from "./partials/Type";
import Sections from "./partials/Sections";
import TimeWindow from "./partials/TimeWindow";
import PubDateTimeWindow from "./partials/PubDateTimeWindow";
import PaidType from "./partials/PaidType";
import VideoFilter from "./partials/VideoFilter";
import Label from "./partials/Label";
import {IGridConfigItem} from "../../../constants/interfaces";
import PostedOnChannel from "./partials/PostedOnChannel";
import Referrers from "./partials/Referrers";
import Tags from "./partials/Tags";
import ConversionFilter from "./partials/ConversionFilter";
import PageType from "./partials/PageType";
import UserNeeds from "./partials/UserNeeds";
import useCurrentBrandsBigscreenSettings from "../../../hooks/useCurrentBrandsBigscreenSettings";

type Props = {
	item: IGridConfigItem,
	updateConfig: Function,
	isEdit: boolean,
	removeItem: React.MouseEventHandler<HTMLButtonElement>,
	id: number
}

const SingleMetric = (props: Props) => {
	const currentBigscreenSettings = useCurrentBrandsBigscreenSettings(props.item.brands);
	const contentType = props.item.content_type;

	const getTimeFrameType = () => {
		if (props.item.content_type === "sessions") {
			return "30min";
		}

		if (["averageReadDepth", "averageScrollDepth"].includes(props.item.content_type)) {
			return "12hours";
		}

		if (["totalReadingTime", "averageReadingTime"].includes(props.item.content_type)) {
			return "from5min";
		}

		return "default";
	};

    return (
		<div className="config-item__list">
			<h2>Single metric</h2>
			<Type
				updateConfig={props.updateConfig}
				bigscreenSettings={currentBigscreenSettings}
				initialEventFields={props.item.event_fields}
				initialValue={contentType}
			/>
			<div className="config-item__selects">
				<UserNeeds
					updateConfig={props.updateConfig}
					userNeedValues={props.item.user_needs}
				/>
			</div>
			<Sections
				updateConfig={props.updateConfig}
				sections={props.item.sections}
				brands={props.item.brands}
				type={props.item.content_type === "videoPageViews" ? "videos" : "feed"}
				isEdit={props.isEdit}
				cellId={props.item.cell_id}
				id={props.id}
				isSectionsDisabled={props.item.content_type === "sessions" || props.item.content_type === "activeUsers"}
			/>

			<div className="config-item__selects">
				<Tags
					updateConfig={props.updateConfig}
					tags={props.item.tags}
					brands={props.item.brands}
					type={props.item.content_type === "videoPageViews" ? "videos" : "feed"}
					isEdit={props.isEdit}
					isDisabled={props.item.brands.length === 0}
					cellId={props.item.cell_id}
					id={props.id}
				/>
				<ConversionFilter
					updateConfig={props.updateConfig}
					conversions={props.item.conversions}
					brands={props.item.brands}
					type="feed"
					isEdit={props.isEdit}
					isDisabled={props.item.brands.length === 0}
					cellId={props.item.cell_id}
					id={props.id}
				/>
			</div>

			<div className="config-item__selects">
				{props.item.content_type !== "activeUsers" &&
					<TimeWindow
						updateConfig={props.updateConfig}
						timeWindow={props.item.time_window}
						isDisabled={["activeUsers", "publishedStories"].includes(props.item.content_type)}
						timeFrameType={getTimeFrameType()}
					/>
				}
				<PubDateTimeWindow
					updateConfig={props.updateConfig}
					pubDateInterval={props.item.pubdate_interval}
					pubDateType={props.item.content_type === 'publishedStories' ? "publishedStories" : "default"}
				/>
			</div>

			<Referrers
				updateConfig={props.updateConfig}
				referrerTypes={props.item.referrer_types}
				referrers={props.item.referrers}
				brands={props.item.brands}
				isEdit={props.isEdit}
				isDisabled={!['webpageviews', 'pageviews'].includes(props.item.content_type) || props.item.brands.length === 0}
				cellId={props.item.cell_id}
				id={props.id}
			/>

			<div className="config-item__selects">
				<PaidType updateConfig={props.updateConfig} value={props.item.paid_type} />
				<VideoFilter updateConfig={props.updateConfig} value={props.item.video_filter} />
				<PageType updateConfig={props.updateConfig} value={props.item.page_type} />
			</div>

			<PostedOnChannel
				isEdit={props.isEdit}
				postedOnChannels={props.item.posted_on_channels}
				isDisabled={['activeUsers', 'sessions'].includes(props.item.content_type)}
				updateConfig={props.updateConfig}
			/>

			{/*<Compared updateConfig={props.updateConfig} value={props.item.compared_to} />*/}
			<Label updateConfig={props.updateConfig} value={props.item.label} />

			<button
				className="btn btn-outline-danger remove-item"
				onClick={props.removeItem}
			>
				Remove
			</button>
		</div>
	);
};

export default SingleMetric;
